import styled from 'styled-components';

export default styled.div`
  height: 1px;
  background: ${({ theme }) => theme.borderColor};
  width: 100%;
`;
